"use strict";

var ethUtil = require('ethereumjs-util');

var ethAbi = require('ethereumjs-abi'); // user, value, unlockTimestamp, entropy


var TYPES = ['address', 'uint256', 'uint256', 'uint256'];

var Hasher = function Hasher() {};

Hasher.hash = function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var encodedMsg = ethAbi.rawEncode(TYPES, args);
  return ethUtil.keccak256(encodedMsg);
};

module.exports = Hasher;